module.exports = __webpack_public_path__ + "static/media/cocktail-search.e1dde8dd.png";